import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button, Stepper, Step, StepLabel, Box, Typography, TextField, MenuItem, Select, IconButton, CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axiosInstance from "../axiosConfig";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteIcon from '@mui/icons-material/Delete';
import { Card, CardContent, Divider } from '@mui/material';

const steps = ['Review Cart', 'Pickup Info', 'Confirm Order', 'Order Confirmation'];

const SubscriptionDialog = ({ open, onClose, cart, totalPrice, setCart ,item }) => {

    const [activeStep, setActiveStep] = useState(0);
    const [pickupLocation, setPickupLocation] = useState('Nags Kitchen Little Elm');
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [name, setName] = useState('');
    const [pickUpDate, setPickUpDate] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [orderId, setOrderId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [deliveryType, setDeliveryType] = useState('pickup');


    useEffect(() => {
        if (item) {
            console.log('Received item:', item);
        }
    }, [item]);

    const handleNext = async () => {
        if (activeStep === 1) {
            validateEmail(email);
            validatePhone(phone);
            if (!emailError && !phoneError && name.trim() && pickupLocation.trim() && pickUpDate.trim() && (deliveryType === 'pickup' || deliveryAddress.trim())) {
                setActiveStep((prev) => prev + 1);
            } else {
                alert("Please complete all required fields correctly.");
            }
        } else if (activeStep === steps.length - 2) {
            await handlePreOrder();
        } else {
            setActiveStep((prev) => prev + 1);
        }
    };

    const validateEmail = (value) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setEmailError(!regex.test(value));
    };

    const validatePhone = (value) => {
        const regex = /^\d{10}$/;
        setPhoneError(!regex.test(value));
    };

    const handleBack = () => {
        setActiveStep((prev) => prev - 1);
    };

    const handlePreOrder = async () => {
        setLoading(true);
        const orderDetails = {
            customer: { name, email, phone, pickupLocation, pickUpDate, deliveryAddress, deliveryType },
            plan: item.id,
            price:item.price,
        };

        try {
            const response = await axiosInstance.post(`/subscribe/customer`, orderDetails);
            setOrderId(response.data);
            setActiveStep((prev) => prev + 1);
            setCart({});
        } catch (error) {
            console.error('Failed to place order:', error);
            alert('Failed to place order. Please try again.');
        }
        setLoading(false);
    };

    const handleClose = () => {
        setActiveStep(0);
        setPickupLocation('Nags Kitchen Little Elm');
        setDeliveryAddress('');
        setName('');
        setEmail('');
        setPhone('');
        setOrderId(null);
        setPickUpDate('');
        setDeliveryType('pickup');
        onClose();
    };

    const handleAddItem = (item) => {
        setCart((prev) => ({
            ...prev,
            [item]: { ...prev[item], quantity: prev[item].quantity + 1 }
        }));
    };

    const handleRemoveItem = (item) => {
        if (cart[item].quantity > 1) {
            setCart((prev) => ({
                ...prev,
                [item]: { ...prev[item], quantity: prev[item].quantity - 1 }
            }));
        }
    };

    const handleDeleteItem = (item) => {
        setCart((prev) => {
            const newCart = { ...prev };
            delete newCart[item];
            return newCart;
        });
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>
                Complete Your Subscription
                <IconButton onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>

                {activeStep === 0 && (
                    <Box>
                        <Box mt={3}>
                            <Card elevation={3} sx={{ borderRadius: 3 }}>
                                <CardContent>

                                    <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
                                        {item.title} : {item.description}
                                    </Typography>
                                    <Divider sx={{ mb: 2 }} />
                                    <Box mb={2}>
                                        <Typography variant="body1" color="text.secondary">
                                            <strong>Curries :</strong> A curated selection of home-style dishes, freshly prepared and delivered.
                                        </Typography>
                                    </Box>
                                    <Box mb={2}>
                                        <Typography variant="body1" color="text.secondary">
                                            <strong>Delivery Days:</strong> TUE to FRI
                                        </Typography>
                                    </Box>
                                    <Box mb={2}>
                                        <Typography variant="body1" color="text.secondary" gutterBottom>
                                            <strong>Delivery Windows:</strong>
                                        </Typography>
                                        <Box pl={2}>
                                            <Typography variant="body2" color="text.secondary">
                                                • <strong>12:00 PM - 4:00 PM</strong> for delivery addresses within <strong>5 miles</strong>
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                • <strong>4:00 PM - 8:00 PM</strong> for delivery addresses between <strong>5 to 10 miles</strong>
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Divider sx={{ my: 2 }} />
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Typography variant="h6" fontWeight="bold">
                                            Total Price:
                                        </Typography>
                                        <Typography variant="h6" color="success.main" fontWeight="bold">
                                            ${item.price}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                    </Box>
                )}

                {activeStep === 1 && (
                    <Box mt={2} display="flex" flexDirection="column" gap={2}>
                        <TextField label="Full Name" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
                        <TextField label="Email" value={email} onChange={(e) => { setEmail(e.target.value); validateEmail(e.target.value); }} error={emailError} helperText={emailError ? "Invalid email" : ""} fullWidth />
                        <TextField label="Phone Number" value={phone} onChange={(e) => { setPhone(e.target.value); validatePhone(e.target.value); }} error={phoneError} helperText={phoneError ? "Invalid phone number" : ""} fullWidth />
                        <TextField select label="Delivery Type" value={deliveryType} onChange={(e) => setDeliveryType(e.target.value)} fullWidth>
                            <MenuItem value="pickup">Pickup</MenuItem>
                            <MenuItem value="delivery">Delivery</MenuItem>
                        </TextField>
                        {deliveryType === 'pickup' && (
                            <TextField label="Pickup Location" value={pickupLocation} InputProps={{ readOnly: true }} onChange={(e) => setPickupLocation(e.target.value)} fullWidth />
                        )}
                        {deliveryType === 'delivery' && (
                            <TextField label="Delivery Address" value={deliveryAddress} onChange={(e) => setDeliveryAddress(e.target.value)} fullWidth />
                        )}
                        <TextField label="Start Date" type="date" value={pickUpDate} onChange={(e) => setPickUpDate(e.target.value)} fullWidth InputLabelProps={{ shrink: true }} />
                    </Box>
                )}

                {activeStep === 2 && (
                    <Box mt={2}>
                        <Typography variant="h6" gutterBottom fontWeight="bold" color="primary">
                            Review Your Info
                        </Typography>

                        <Typography><strong>Name:</strong> {name}</Typography>
                        <Typography><strong>Email:</strong> {email}</Typography>
                        <Typography><strong>Phone:</strong> {phone}</Typography>
                        <Typography><strong>Delivery Type:</strong> {deliveryType}</Typography>
                        {deliveryType === 'pickup' && (
                         <Typography><strong>Pickup Location:</strong> {pickupLocation}</Typography>
                        )}
                        {deliveryType === 'delivery' && <Typography><strong>Address:</strong> {deliveryAddress}</Typography>}
                        <Typography><strong>Start Date:</strong> {pickUpDate}</Typography>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography><strong>Selected Plan:</strong>  {item.title}</Typography>
                            </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography variant="h6" fontWeight="bold">
                                Total Price:
                            </Typography>
                            <Typography variant="h6" color="success.main" fontWeight="bold">
                                ${item.price}
                            </Typography>
                        </Box>
                    </Box>
                )}

                {activeStep === 3 && (
                    <Box mt={2}>
                        {loading ? <CircularProgress /> : (
                            <Typography variant="h6" color="green">
                               Your Subscription Request is been sent . Our Team member will reach out to you Shortly !!
                            </Typography>
                        )}
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                {activeStep > 0 && activeStep < steps.length - 1 && (
                    <Button onClick={handleBack}>Back</Button>
                )}
                {activeStep < steps.length - 1 && (
                    <Button onClick={handleNext} variant="contained">{activeStep === steps.length - 2 ? 'Subscribe' : 'Next'}</Button>
                )}
                {activeStep === steps.length - 1 && (
                    <Button onClick={handleClose} variant="contained">Close</Button>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default SubscriptionDialog;
